import { schema } from 'normalizr';

import type {
  ChatAnnotation,
  ChatChannel,
  ChatChannelEvent,
  ChatComment,
  ChatShare,
  ChatTask,
} from '@frontend/api';

export const commentSchema = new schema.Entity<ChatComment>('comments', {});

export const taskSchema = new schema.Entity<ChatTask>('tasks', {});

export const annotationSchema = new schema.Entity<ChatAnnotation>(
  'annotations',
  {
    comments: [commentSchema],
    task: taskSchema,
  },
);

export const shareSchema = new schema.Entity<ChatShare>('shares', {});

export const channelEventSchema = new schema.Entity<ChatChannelEvent>(
  'channelEvents',
  {},
);

export const channelSchema = new schema.Entity<ChatChannel>('channels', {
  annotations: [annotationSchema],
  shares: [shareSchema],
  channelEvents: [channelEventSchema],
});
